import i18n from '@/utils/i18n';
import React from 'react';
import { captureException } from '@/utils/sentry';
import { SnapPeasCard } from './snap-peas-card';
import { StyleSheet, Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  {
    children: React.ReactNode;
  },
  State
> {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <View style={styles.base}>
          <SnapPeasCard
            buttonProps={{
              children: i18n.t('reload'),
              onPress: () => {
                location.reload();
              },
              trackingData: {
                name: 'error_boundary.refresh_button',
              },
            }}
          >
            <Text style={TYPOGRAPHY.cardMessageText}>
              {i18n.t('toast.standard_error')}
            </Text>
          </SnapPeasCard>
        </View>
      );
    }

    return this.props.children;
  }
}

const styles = StyleSheet.create({
  base: {
    alignSelf: 'center',
    flex: 1,
    justifyContent: 'center',
    width: 320,
  },
});
